__turbopack_context__.v({
  "created-by": "instructor-display-module-scss-module__-KB2AG__created-by",
  "google-icon": "instructor-display-module-scss-module__-KB2AG__google-icon",
  "instructor-container": "instructor-display-module-scss-module__-KB2AG__instructor-container",
  "instructor-header-details": "instructor-display-module-scss-module__-KB2AG__instructor-header-details",
  "instructor-header-image-container": "instructor-display-module-scss-module__-KB2AG__instructor-header-image-container",
  "instructor-header-leading": "instructor-display-module-scss-module__-KB2AG__instructor-header-leading",
  "instructor-link": "instructor-display-module-scss-module__-KB2AG__instructor-link",
  "with-community-badge": "instructor-display-module-scss-module__-KB2AG__with-community-badge",
});
